import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRightIcon, CheckIcon } from '@heroicons/react/24/outline';
import type { PageHeroProps } from '../components/page-templates/SitePageTemplates';

const PHOTO = process.env.REACT_APP_SITE3S === '1'
  ? `${process.env.PUBLIC_URL}/assets/images/warehouse/warehouse-operations.webp`
  : `${process.env.PUBLIC_URL}/assets/images/warehouse/changi-ftz-racking.jpg`;

const titleWithAccent = (title: string, highlight?: string) => {
  if (!highlight || !title.includes(highlight)) return title;
  const [before, after] = title.split(highlight);
  return <>{before}<span>{highlight}</span>{after}</>;
};

const WarehousePageHero: React.FC<PageHeroProps> = ({
  eyebrow, title, description, highlight, actions = [], badges = [], metrics = [],
  panelEyebrow, panelTitle, panelDescription, panelItems = [],
}) => (
  <section className="site3-page-hero">
    <div className="site3-page-photo" aria-hidden="true"><img src={PHOTO} alt="" /></div>
    <div className="site3-page-container">
      <div className="site3-page-copy">
        <p className="site3-eyebrow"><span />{eyebrow}</p>
        <h1>{titleWithAccent(title, highlight)}</h1>
        <p className="site3-page-description">{description}</p>
        {actions.length > 0 && <div className="site3-page-actions">{actions.map((action) => <Link key={`${action.href}-${action.label}`} to={action.href} className={action.variant === 'secondary' ? 'site3-action site3-action-secondary' : 'site3-action site3-action-primary'}>{action.label}{action.variant !== 'secondary' && <ArrowRightIcon />}</Link>)}</div>}
        {badges.length > 0 && <div className="site3-page-badges">{badges.map((badge) => <span key={badge}><CheckIcon />{badge}</span>)}</div>}
        {metrics.length > 0 && <div className="site3-page-metrics">{metrics.map((metric) => <div key={metric.label}><strong>{metric.value}</strong><span>{metric.label}</span></div>)}</div>}
      </div>
      {(panelTitle || panelItems.length > 0) && <aside className="site3-page-panel">
        {panelEyebrow && <p className="site3-eyebrow"><span />{panelEyebrow}</p>}
        {panelTitle && <h2>{panelTitle}</h2>}
        {panelDescription && <p className="site3-panel-description">{panelDescription}</p>}
        {panelItems.length > 0 && <div className="site3-panel-items">{panelItems.map((item, index) => <div key={item.title} className="site3-panel-item"><span className="site3-panel-number">0{index + 1}</span><div><h3>{item.title}</h3><p>{item.description}</p></div></div>)}</div>}
      </aside>}
    </div>
  </section>
);

export default WarehousePageHero;
